<template>
  <div class="d-flex justify-center" style="min-height:500px" id="loginPage">
    <v-row align="center" justify="center">
      <v-col cols="12" sm="8" md="6">
        <loginForm />
      </v-col>
    </v-row>
  </div>
</template>
<script>
import loginForm from "@/components/login";
import getInfoTable from "@/util/infoTable.js";

export default {
  name: "loginPage",
  components: {
    loginForm,
  },
  created() {
    if (this.$route.name === "Login") {
      if (this.$store.state.operators.credit === undefined) {
        getInfoTable();
      }
    }
  },
  watch: {
    $route(val) {
      if (val.name === "Login") {
        if (this.$store.state.operators.credit === undefined) {
          getInfoTable();
        }
      }
    },
  },
};
</script>
